/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { h } from "preact";
import styled from "styled-components";
import SearchSrc from "@images/icon/search.png";
import { useEffect, useRef, useState } from "preact/hooks";
import homeSrc from "@images/icon/qiandao.svg";
import BackSrc from "@images/icon/ic_arrow.png";
import "./style.css";
import { route } from "preact-router";
import store from "../../../store";
import { observer } from "mobx-react";
let flag = true;
const SearchWrap: any = ({ store }: any) => {
    const {
        currentPage,
        memberWhiteFlag,
        onFocus,
        searchInputTextChange,
        getProductList,
        keywords = "",
        mode,
        indexScrollY = 0,
        BackIndex,
    } = store;
    const jumpPage = () => {
        const search = new URLSearchParams(window.location.search);
        route(`/signin?${search.toString()}`);
    }
    const SearchRef: any = useRef();
    const [threshold, setThreshold] = useState(30);
    const action = (e: any) => {
        SearchRef.current.blur();
        getProductList();
    };
    const formOutDiv: any = useRef();
    useEffect(() => {
        document.addEventListener("compositionstart", (e) => {
            flag = false;
        })
        document.addEventListener("compositionend", (e) => {
            flag = true;
            searchInputTextChange(e);
        })
        setThreshold(formOutDiv?.current.offsetTop)
    }, [])
    return (
        <FormOut style={{display:(currentPage==1||currentPage==2||currentPage==99)?"block":"none"}} ref={formOutDiv} className={currentPage==1? (indexScrollY > threshold?"form_out_home":"form_out_home form_out_home_bg") :(currentPage==99?"form_out_middle":"form_out_home")}>
            <FormInner>
                <form
                    style={{ width: "100%" }}
                    action="#"
                    onSubmit={action}
                    onKeyDown={(e) => {
                        if (e.keyCode == 13) action(e);
                    }}
                >
                    <input
                        type="text"
                        style={{
                            width: 0,
                            height: 0,
                            position: "absolute",
                            top: -1000,
                        }}
                    />
                    <SearchOut>
                        {
                            mode == "default" && memberWhiteFlag && currentPage === 1 && <SiginWrap> <SiginIcon src={homeSrc} onClick={jumpPage} /></SiginWrap>
                        }
                        {mode != 'default' && <BackOut>
                            <BackIcon src={BackSrc} onClick={BackIndex} />
                        </BackOut>}
                        <SearchInner className="search_inner">
                            <Icon src={SearchSrc} />
                            <input
                                id="search-input-id-all"
                                ref={SearchRef}
                                className="search-input"
                                placeholder="输入商品名或粘贴宝贝标题/链接"
                                type="Search"
                                onFocus={onFocus}
                                onChange={(e: any) => {
                                    if (flag) {
                                        searchInputTextChange(e)
                                    }
                                }}
                                value={keywords}
                            />
                        </SearchInner>
                    </SearchOut>
                </form>
            </FormInner>
        </FormOut>)
}

export default observer(SearchWrap);
const FormOut = styled.div`
    width: 750px;
    
 `;
const SiginWrap = styled.div`
    margin-right:16px;
    width: 100px;
    height: 90px;
    padding-top:2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
 `;
const SiginIcon = styled.img`
    width: 100px;
 `;
const FormInner = styled.div`
    width: 100%;
 `;
const SearchOut = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
 `;
const SearchInner = styled.div`
   width :100%;
   height: 78px;
   display: flex;
   flex-direction: row;
   align-items: center;
   border-radius: 16px;
   background: #F6F6F6;
   padding: 0 24px;
 `;
const Icon = styled.img`
    width: 29px;
    height: 32px;
    margin-right:16px;
 `;
const BackOut = styled.div`
    padding-left:28px;
    width: 67px;
    height: 62px;
    display: flex;
    flex-direction: row;
    align-items: center;
 `;
const BackIcon = styled.img`
    width: 19px;
    height: 32px;
 `;